import { PsaQueryKeys } from "components/PSA/queryKeys";
import { useTypedQuery } from "hooks";
import { ApiInstance } from "utils/Api";

export const useAppointmentWidget = (appointment_id: number, enabled: boolean) =>
  useTypedQuery({
    queryKey: PsaQueryKeys.appointmentWidget,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.post(endpoint, { appointment_id }, baseUrl))?.data ?? null,
    enabled
  });
